import { ACTIVE_NETWORK } from './network';

// ============================================================
// CONTRACT ADDRESSES
// ------------------------------------------------------------
// Replace these with your deployed contract addresses.
// ============================================================

const CONTRACT_ADDRESSES = {
  mainnet: '0x5450fdedbee735689e7598e5092a03b2027a3820',
  testnet: '0xe27fc7c561eb4F31175eD0D4104f342d21227bCF'
};

export const AMSG_CONTRACT_ADDRESS = CONTRACT_ADDRESSES[ACTIVE_NETWORK];

// Frontend-enforced minimum claim. The deployed contract does not enforce this —
// we block sub-minimum claims here to keep withdrawals predictable for users.
export const MIN_CLAIM_USDT = 10;

export const PLAN_INFO = [
  { id: 0, rank: 'BRONZE',   name: '60 Days',  days: 60,  dailyROI: '0.6%', totalROI: '36%',  color: '#cd7f32' },
  { id: 1, rank: 'SILVER',   name: '90 Days',  days: 90,  dailyROI: '0.7%', totalROI: '63%',  color: '#c0c0c0' },
  { id: 2, rank: 'GOLD',     name: '120 Days', days: 120, dailyROI: '0.8%', totalROI: '96%',  color: '#ffd700' },
  { id: 3, rank: 'PLATINUM', name: '180 Days', days: 180, dailyROI: '0.9%', totalROI: '162%', color: '#00d4ff' },
  { id: 4, rank: 'DIAMOND',  name: '360 Days', days: 360, dailyROI: '1.0%', totalROI: '360%', color: '#b855ff' }
];

export const LEVEL_PERCENTAGES = [
  10, 20, 30, 40, 50, 60, 70, 80, 90,
  100, 100, 100, 100, 100, 100
];

// 15 referral-tier ranks. Index = level - 1.
export const LEVEL_RANKS = [
  'NOVICE',      // L1
  'APPRENTICE',  // L2
  'ADEPT',       // L3
  'EXPERT',      // L4
  'VANGUARD',    // L5
  'CHAMPION',    // L6
  'ELITE',       // L7
  'WARRIOR',     // L8
  'KNIGHT',      // L9
  'LORD',        // L10
  'SOVEREIGN',   // L11
  'TITAN',       // L12
  'MYTHIC',      // L13
  'LEGEND',      // L14
  'IMMORTAL'     // L15
];

// Color cue per rank (used in badges)
export const LEVEL_RANK_COLORS = [
  '#a0b3cc', '#00d4ff', '#00ff88', '#5cf7ff', '#ffaa00',
  '#ff6b9d', '#b855ff', '#ff2e63', '#ffd700', '#d182ff',
  '#00d4ff', '#b855ff', '#ff2e63', '#ffd700', '#5cf7ff'
];

export const getRankFromEligibility = (eligibility) => {
  if (!eligibility || !eligibility.length) return { level: 0, name: 'GUEST', color: '#6b7a92' };
  let highest = 0;
  for (let i = 0; i < eligibility.length; i++) {
    if (eligibility[i]) highest = i + 1;
  }
  if (highest === 0) return { level: 0, name: 'GUEST', color: '#6b7a92' };
  return {
    level: highest,
    name: LEVEL_RANKS[highest - 1] || 'UNRANKED',
    color: LEVEL_RANK_COLORS[highest - 1] || '#00d4ff'
  };
};

export const ACTIVITY_TYPES = {
  1: { label: 'Invest', color: '#00d4ff' },
  2: { label: 'ROI Earned', color: '#00ff88' },
  3: { label: 'Level Income', color: '#b855ff' },
  4: { label: 'Claim', color: '#ffaa00' },
  5: { label: 'Principal Withdraw', color: '#ff6b9d' }
};
